/* tslint:disable */
/* eslint-disable */
/* @relayHash 6f0c5459117fa7621d0c6c8ae6ea2c61 */

import { ConcreteRequest } from "relay-runtime";
export type DelegatePickerQueryVariables = {
    text?: string | null;
};
export type DelegatePickerQueryResponse = {
    readonly delegates: {
        readonly edges: ReadonlyArray<{
            readonly uuid: string;
            readonly firstName: string;
            readonly lastName: string;
            readonly email: string | null;
            readonly profileImageUrl: string | null;
            readonly hasActiveBackgroundCheck: boolean;
        } | null> | null;
    } | null;
};
export type DelegatePickerQuery = {
    readonly response: DelegatePickerQueryResponse;
    readonly variables: DelegatePickerQueryVariables;
};



/*
query DelegatePickerQuery(
  $text: String
) {
  delegates(filter: {name: $text}, page: {limit: 20}) {
    edges {
      uuid
      firstName
      lastName
      email
      profileImageUrl
      hasActiveBackgroundCheck
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "text",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "delegates",
            "storageKey": null,
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "filter",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "name",
                            "variableName": "text"
                        }
                    ]
                },
                {
                    "kind": "Literal",
                    "name": "page",
                    "value": {
                        "limit": 20
                    }
                }
            ],
            "concreteType": "DelegatePage",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Delegate",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "uuid",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "firstName",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "lastName",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "email",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "profileImageUrl",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasActiveBackgroundCheck",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "DelegatePickerQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "DelegatePickerQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "DelegatePickerQuery",
            "id": null,
            "text": "query DelegatePickerQuery(\n  $text: String\n) {\n  delegates(filter: {name: $text}, page: {limit: 20}) {\n    edges {\n      uuid\n      firstName\n      lastName\n      email\n      profileImageUrl\n      hasActiveBackgroundCheck\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'cfbe89eace067af331f25f4b153073d4';
export default node;
